export default "__VITE_ASSET__DB_sKxSb__"